import { render, staticRenderFns } from "./scene5animation.vue?vue&type=template&id=5de05459&scoped=true&"
import script from "./scene5animation.vue?vue&type=script&lang=js&"
export * from "./scene5animation.vue?vue&type=script&lang=js&"
import style0 from "./scene5animation.vue?vue&type=style&index=0&id=5de05459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de05459",
  null
  
)

export default component.exports